module.exports = __webpack_public_path__ + "static/media/ampai.7e63d708.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Onboarding/ampai.png
// module id = 178
// module chunks = 0